import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { DateTime } from 'luxon';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

interface DateFormInputProps {
  id?: string;
  field?: string;
  label?: string;
  required?: boolean;
  views?: ('date' | 'year' | 'month' | 'hours' | 'minutes')[];
  format?: string;
  value?: DateTime | undefined;
  setValue?: (value: DateTime | undefined) => void;
}

export function DateTimeFormInput(props: DateFormInputProps) {
  const [value, setValue] = useState<DateTime | undefined>(props.value);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const {id, label, field, required} = props;
  return (
    <FormControl error={false} fullWidth={true}>
      <KeyboardDateTimePicker
        id={id ? id : 'input_' + field}
        label={label}
        format={props.format ? props.format : 'dd.MM.yyyy HH:mm:ss'}
        ampm={false}
        value={value ? value : null}
        views={props.views || []}
        variant={'dialog'}
        clearable={true}
        fullWidth={true}
        onChange={(date: MaterialUiPickersDate | null, value?: string | null) => {
          let result: DateTime | undefined = undefined;
          if (value && date && !date.isValid) {
            return;
          }
          if (date) {
            result = date;
          } else {
            result = undefined;
          }
          setValue(result);
          if (props.setValue) {
            props.setValue(result);
          }
        }}
        InputLabelProps={{
          shrink: true,
        }}
        required={required || false}
        error={false}
      />
      <FormHelperText>{}</FormHelperText>
    </FormControl>
  );
}

